import PdfJsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?worker';

let isConfigured = false;

export const configurePdfJsWorker = (pdfjsLib: {
  version?: string;
  GlobalWorkerOptions: { workerSrc?: string; workerPort?: Worker };
}) => {
  if (isConfigured) return;

  if (typeof window !== 'undefined') {
    try {
      pdfjsLib.GlobalWorkerOptions.workerPort = new PdfJsWorker();
      isConfigured = true;
      return;
    } catch (error) {
      console.warn('Failed to initialize bundled PDF.js worker, falling back to CDN worker.', error);
    }
  }

  const version = pdfjsLib.version ?? '4.10.38';
  pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;
  isConfigured = true;
};
